import { SETTLEMENT_PAYMENT_REQUIRED_FIELDS } from "./constants";
import { formatDateForApi, parseDateForPicker } from "./date";

export const getSettlementPaymentEntityId = (value) => value?.pk ?? value?.id ?? null;

export const normalizeSettlementPaymentAmount = (value) =>
  value === "" || value === null || value === undefined ? null : Number(value).toFixed(2);

export const mapSettlementPaymentToFormValues = (paymentData = null) => ({
  paymentAmount: paymentData?.amount ?? "",
  totalAmount: paymentData?.totalAmount ?? paymentData?.total_amount ?? "",
  paymentType: paymentData?.checkType ?? paymentData?.check_type ?? "",
  paymentId: paymentData?.checkNumber ?? paymentData?.check_number ?? "",
  paymentTo: paymentData?.paidTo ?? paymentData?.paid_to ?? null,
  paymentFrom: paymentData?.paidBy ?? paymentData?.paid_by ?? null,
  intendedRecipient: paymentData?.intendedRecipient ?? paymentData?.intended_recipient ?? null,
  paymentDate: parseDateForPicker(paymentData?.checkDate ?? paymentData?.check_date),
  depositDate: parseDateForPicker(paymentData?.depositDate ?? paymentData?.deposit_date),
  cnbDepositDate: parseDateForPicker(paymentData?.cnbDepositDate ?? paymentData?.cnb_deposit_date),
  batchNumber: paymentData?.batchNumber ?? paymentData?.batch_number ?? "",
  receivable: paymentData?.receivable ?? "",
  notes: paymentData?.notes ?? "",
});

export const buildSettlementPaymentPayload = (formValues, caseId = null) => {
  const payload = {
    check_number: formValues.paymentId || "",
    amount: normalizeSettlementPaymentAmount(formValues.paymentAmount),
    total_amount: normalizeSettlementPaymentAmount(formValues.totalAmount),
    check_date: formatDateForApi(formValues.paymentDate),
    check_type: formValues.paymentType || null,
    paid_to: getSettlementPaymentEntityId(formValues.paymentTo),
    paid_by: getSettlementPaymentEntityId(formValues.paymentFrom),
    intended_recipient: getSettlementPaymentEntityId(formValues.intendedRecipient),
    deposit_date: formatDateForApi(formValues.depositDate),
    cnb_deposit_date: formatDateForApi(formValues.cnbDepositDate),
    batch_number: formValues.batchNumber || "",
    receivable: formValues.receivable || "",
    notes: formValues.notes || "",
  };

  if (caseId) {
    payload.case = Number(caseId);
  }

  return payload;
};

export const buildSettlementPaymentAddPayload = (formValues, caseId) => {
  const payload = buildSettlementPaymentPayload(formValues, caseId);

  return Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== "" && value !== undefined)
  );
};

export const buildSettlementPaymentDirtyPayload = (initialValues, currentValues) => {
  const initialPayload = buildSettlementPaymentPayload(initialValues);
  const currentPayload = buildSettlementPaymentPayload(currentValues);

  return Object.fromEntries(
    Object.entries(currentPayload).filter(([key, value]) => initialPayload[key] !== value)
  );
};

export const isSettlementPaymentFormDirty = (initialValues, currentValues) =>
  Object.keys(buildSettlementPaymentDirtyPayload(initialValues, currentValues)).length > 0;

export const isSettlementPaymentSaveDisabled = (formValues) =>
  SETTLEMENT_PAYMENT_REQUIRED_FIELDS.some((fieldName) => !formValues[fieldName]);
